<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let value;

  $: tags = value ? value.split(",") : ""
</script>

<div class="container">
  {#each tags as tag}
    <div class="tag" on:click={() => dispatch("click", {tag})}>{tag.substring(1)}</div>
  {:else}
    {""}
  {/each}
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    gap: 5px;
  }

  .tag {
    border-radius: 2px;
    background-color: #efefef;
    border: 1px solid #ccc;
    text-align: center;
    padding: 0px 3px;
    cursor: pointer;
  }
</style>